export const FilterObj = {

    customerNameKey: "",
    shipNameImokey: "",
    servicetype: "",
    reportstatus: "",

    Fqtsamplestatus: "",
    Fqtreportstatus: "",
    Fqtbunkerport: "",
    Fqtbunkercity: "",
    Fqtsamplenumber: "",
    Fqtbargename: "",
    Fqtfuelgrade: "",
    Fqtlab:"",
    FqtSupplier:"",
    FqtShipType:"",
    FqtOffSpec:"",
    Fqtreportstartdate: null,
    Fqtreportenddate: null,
    Fqtsamplestartdate: null,
    Fqtsampleenddate: null,
    Fqtbunkerstartdate: null,
    Fqtbunkerenddate: null,

    lubesamplestatus: "",
    lubereportstatus: "",
    lubelab: "",
    lubeequipname: '',
    lubeequipmake: "",
    lubeequipmodel: "",
    lobrand: "",
    lograde: "",
    lubeShipType:"",
    lubesamplestartdate: null,
    lubesampleenddate: null,
    lubereportstartdate: null,
    lubereportenddate: null,

    Totsamplestatus: "",
    Totreportstatus: "",
    Totserialnumber: "",
    Totlab:"",
    Totlocation: "",
    Totclientcontract: "",
    Totvoltage: "",
    Totmanufacture: "",
    Totsamplenumber: "",
    TotRating:"",
    TotUnitDescription:"",
    TotSubCustomerName:"",
    Totsamplestartdate: null,
    Totsampleenddate: null,
    Totreportstartdate: null,
    Totreportenddate: null,
    TotTransformerName: "",
    AssetscustomerNameKey: "",
    Assetsequipment: "",
}